<template>
    <div class="options">
        <option-box-radio
            v-for="option in options"
            :key="option.value"
            v-model="localSelected"
            :option="option"
        />
    </div>
</template>
<script>
    export default {
        model: {
            prop: 'selected',
            event: 'input',
        },
        props: {
            options: {
                required: true,
                type: Array,
            },
            selected: {
                type: [String, Number],
                required: false,
                default: null,
            },
        },
        computed: {
            localSelected: {
                get() {
                    return this.selected;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                },
            },
        },
    };
</script>
